import { Button, Drawer } from '@mui/material';
import React, { type FC } from 'react';

import { type MatchingPatients } from '../../api/index.js';
import { MatchingPatientsList } from '../Streams/index.js';

interface StreamsFilterDrawerProps {
  open: boolean;
  onClose: () => void;
  checkedItems: { [key: string]: boolean };
  patients?: MatchingPatients[];
  onToggle: (patientId: string) => void;
  onClear: () => void;
  disabledButton: boolean;
}
const StreamsFilterDrawer: FC<StreamsFilterDrawerProps> = ({
  open,
  onClose,
  onClear,
  patients,
  checkedItems,
  onToggle,
  disabledButton,
}) => {
  return (
    <Drawer
      anchor={'right'}
      open={open}
      onClose={onClose}
      sx={{
        zIndex: 1300,
      }}
    >
      <Button variant="contained" disableElevation disabled={disabledButton} onClick={onClear} sx={{ m: 1 }}>
        Clear
      </Button>
      <MatchingPatientsList patients={patients} onToggle={onToggle} checkedItems={checkedItems} />
    </Drawer>
  );
};

export default StreamsFilterDrawer;
